
const BASE = '/assets/images';

/* ================= IMAGES ================= */

export const imagePath = {
  com1: `${BASE}/img/com1_new.svg`,
  com2: `${BASE}/img/com2_new.svg`,
  com3: `${BASE}/img/com3_new.svg`,
  com4: `${BASE}/img/com4_new.svg`,
  com5: `${BASE}/img/com5_new.svg`,
  com6: `${BASE}/img/com6_new.svg`,
  com7: `${BASE}/img/com7_new.svg`,
  com8: `${BASE}/img/com8_new.svg`,
  com9: `${BASE}/img/com9_new.svg`,
  com10: `${BASE}/img/com10_new.svg`,

  instagram: `${BASE}/img/instagram.svg`,
  youtube: `${BASE}/img/youtube.svg`,
  linkdin: `${BASE}/img/linkdin.svg`,
  discord: `${BASE}/img/discord.svg`,
  x: `${BASE}/img/x.svg`,

  logo_small: `${BASE}/img/logo-small.png`,
  card: `${BASE}/img/card.svg`,
  logo: `${BASE}/img/logo.png`,
  visual_editor: `${BASE}/img/visual-editor.png`,
  XR: `${BASE}/img/XR.svg`,
  logoImage: `${BASE}/img/Group 323.svg`,
  SearchIcon: `${BASE}/img/Group 99.svg`,
  group96Image: `${BASE}/img/Group 96.svg`,

  HelpCenterLevelIII: `${BASE}/img/helpCenterLevelII.png`,
  HelpCenterLevelIII_2: `${BASE}/img/HelpCenterLevelII_2.png`,
  cursorImg: `${BASE}/img/cursor-icon.svg`,
  medhaLogo: `${BASE}/img/medha_logo.svg`,
  qrCodeImage: `${BASE}/img/qrcode.png`,

  textcontainer: `${BASE}/img/CompressedImage/text-container.webp`,
  mapImage: `${BASE}/img/map.png`,
  aboutus: `${BASE}/img/about_us.svg`,
  spatialgridSquad: `${BASE}/img/spatialgrid_squad.svg`,

  arjunReddy: `${BASE}/img/arjun_reddy.svg`,
  krishna: `${BASE}/img/Krishna_Chaitanya.svg`,
  ranga: `${BASE}/img/Ranga_Maramraju.svg`,
  ramji: `${BASE}/img/Ramji_Geddam.svg`,

  mrGlasses: `${BASE}/img/mr_glasses.svg`,
  xrGlasses: `${BASE}/img/XR-glasses.svg`,
  environment: `${BASE}/img/environment.svg`,
  letency: `${BASE}/img/latency.svg`,
  multiUser: `${BASE}/img/multi-user.svg`,
  plus: `${BASE}/img/plus.svg`,
  reaearch1: `${BASE}/img/research1.svg`,
  reaearch2: `${BASE}/img/research2.svg`,
  gridmountain: `${BASE}/img/grid-mountain.svg`,
  JoinUsImg: `${BASE}/img/joinUsBg.svg`,
  creme21: `${BASE}/img/creme21.jpg`,

  MRGlassesWeb: `${BASE}/img/MRGlassesWeb.svg`,
  MRGlassesWeb2: `${BASE}/img/MRGlassesWeb2.svg`,
  OsGrid: `${BASE}/img/OsGrid.svg`,

  immersiveAnatomy2: `${BASE}/img/CompressedImage/Immersive-Anatomy2.webp`,
  Raghava: `${BASE}/img/Raghava.svg`,
  Singareni: `${BASE}/img/Singareni.svg`,
  MedhaServo: `${BASE}/img/Medha-Servo.svg`,
  Americana: `${BASE}/img/CompressedImage/Americana.webp`,
  RST: `${BASE}/img/CompressedImage/RST.webp`,
  Cremeweb21: `${BASE}/img/Cremeweb21.svg`,
  GeospatialManagement: `${BASE}/img/Geospatial-Management.svg`,
  FourdImmersive: `${BASE}/img/CompressedImage/4D-Immersive.webp`,
  MissileSimulation: `${BASE}/img/Missile-Simulation.svg`,
  Flying: `${BASE}/img/CompressedImage/flying.webp`,
  VrTraining: `${BASE}/img/CompressedImage/VrTraining.webp`,
  Research4: `${BASE}/img/Research4.svg`,

  VRLady: `${BASE}/img/VR-Lady.svg`,

  // //================= Platform Page Images ==================//
  superCharge: `${BASE}/img/SuperCharge.svg`,
  arMobileSet: `${BASE}/img/ArMobileSet.svg`,
  successMactrix: `${BASE}/img/SuccesMactrix.svg`,
  SuperChargeAnalytics: `${BASE}/img/SuperChargeanalytics.svg`,
  superChargeAutomation: `${BASE}/img/SuperChargeAutomation.svg`,
  superChargeMultiplayer: `${BASE}/img/SuperChargeMultiplayer.svg`,
  superChargeTeam: `${BASE}/img/SuperchargeTeam.svg`,
  superChargeMUltiDeployment: `${BASE}/img/CompressedImage/SuperchargeMultiDeployment.webp`,
  superChargeLibrary: `${BASE}/img/CompressedImage/SuperChargeLibrary.webp`,
  mindsLab: `${BASE}/img/CompressedImage/MindsLab.webp`,

  // //================= Multiplayer Page Images ==================//

  voiceGesture: `${BASE}/img/Voice-Gesture.svg`,
  statePersistence: `${BASE}/img/State-Persistence.svg`,
  realtimePosition: `${BASE}/img/RealTime-Position.svg`,
  interactionZone: `${BASE}/img/Interaction-Zones.svg`,
  cordinateSystem: `${BASE}/img/Cordinate-System.svg`,
  awearnessAvatar: `${BASE}/img/CompressedImage/Awearness-Avatar.webp`,

  // //================= Real Time Analytics Page Images ==================//

  userTimeLineJourney: `${BASE}/img/UserTimeline-Journey.svg`,
  realTimeEventState: `${BASE}/img/RealTime-EventState.svg`,
  prediction: `${BASE}/img/Prediction.svg`,
  interactionHeatmap: `${BASE}/img/Interaction-Heatmap.svg`,
  crossDeviceAnalytics: `${BASE}/img/CompressedImage/CrossDevice-Analytics.webp`,
  spatialgridTelemetry: `${BASE}/img/Spatialgrid-Telemetry.svg`,

  //================= Companies Page Images ==================//
  BrandPower: `${BASE}/img/Companies/brand-power.png`,
  Medha: `${BASE}/img/Companies/Medha.png`,
  MinistryOfDefence: `${BASE}/img/Companies/mod.png`,
  RaghavaCompany: `${BASE}/img/Companies/raghava.png`,
  ISRO: `${BASE}/img/Companies/isro.png`,
  SCCL: `${BASE}/img/Companies/sccl.png`,
  NRSC: `${BASE}/img/Companies/nrsc.png`,
  RSTCompany: `${BASE}/img/Companies/rst.png`,
  AmericanaCompany: `${BASE}/img/Companies/americana.png`,
  LifeSciences: `${BASE}/img/Companies/life-sciences.png`,
  CorpusCodex: `${BASE}/img/Companies/corpus-codex.png`,
  Company12: `${BASE}/img/Companies/company12.png`,

  // //================= Spatial Ai Page Images ==================//

  spatialContantCreation: `${BASE}/img/SpatialContent-Creation.svg`,
  adaptiveAgent: `${BASE}/img/CompressedImage/Adaptive-Agent.webp`,
  realTimeSimulation: `${BASE}/img/RealTime-Simulation.svg`,
  multiModolUnderstanding: `${BASE}/img/MUltiModol-UnderStanding.svg`,
  predictiveInsightSupport: `${BASE}/img/PredictiveInsight-Support.svg`,
  statePersistenceLearning: `${BASE}/img/StatePersistence-Learning.svg`,

  // //================= University Alliance Page Images ==================//

  jointResearch: `${BASE}/img/JointResearch.svg`,
  DevelopmentSkill: `${BASE}/img/Development-Skill.svg`,
  industryInovation: `${BASE}/img/Industry-Inovation.svg`,
  manipalLogo: `${BASE}/img/ManipalLogo.svg`,
  research3: `${BASE}/img/Research3.svg`,
  Union: `${BASE}/img/Union.svg`,
  Union2: `${BASE}/img/Union2.svg`,
  Union3: `${BASE}/img/Union3.svg`,
  ImmersiveCard1: `${BASE}/img/ImmersiveCard1.svg`,
  ImmersiveCard2: `${BASE}/img/ImmersiveCard2.svg`,
  ImmersiveCard3: `${BASE}/img/ImmersiveCard3.svg`,
  ImmersiveCard4: `${BASE}/img/ImmersiveCard4.svg`,
  UserCard1: `${BASE}/img/UserCard1.svg`,
  UserCard2: `${BASE}/img/UserCard2.svg`,
  RaghvaLife: `${BASE}/img/RaghvaLife.svg`,
  SingareniLogo: `${BASE}/img/Singareni-Logo.svg`,
  VideoBg: `${BASE}/img/VideoBg.svg`,
  UserCard3: `${BASE}/img/UserCard3.svg`,
  ArCard1: `${BASE}/img/ArCard1.svg`,
  ImmersionGlass: `${BASE}/img/ImmersionGlass.svg`,
  SpatilOs: `${BASE}/img/SpatilOs.svg`,
  DefenceAerospaceMobile: `${BASE}/img/CompressedImage/DefenceAerospaceMobile.webp`,
  MissionReadyMobile: `${BASE}/img/CompressedImage/MissionReadyMobile.webp`,
  EducationTrainingMobile: `${BASE}/img/EducationTrainingMobile.svg`,
  EducationSticksMobile: `${BASE}/img/CompressedImage/EducationSticksMobile.webp`,
  IndustrialWebMobile: `${BASE}/img/CompressedImage/IndustrialWebMobile.webp`,
  experienceProductMobile: `${BASE}/img/experienceProductMobile.svg`,
  HealthCarePharmaMobile: `${BASE}/img/CompressedImage/HealthCarePharmaMobile.webp`,
  SaferTrainingMobile: `${BASE}/img/CompressedImage/SaferTrainingMobile.webp`,
  AutomotiveTransportationMobile: `${BASE}/img/CompressedImage/AutomotiveTransportationMobile.webp`,
  RealStateArchitectureMobile: `${BASE}/img/CompressedImage/RealStateArchitectureMobile.webp`,
  SpaceRealizedMobile: `${BASE}/img/CompressedImage/SpaceRealizedMobile.webp`,
  EnergyMiningMobile: `${BASE}/img/CompressedImage/EnergyMiningMobile.webp`,
  OperateMobile: `${BASE}/img/CompressedImage/OperateMobile.webp`,
  TourismHospitalityMobile: `${BASE}/img/CompressedImage/TourismHospitalityMobile.webp`,
  CommondControl: `${BASE}/img/CommondControl.svg`,

  UserGlass: `${BASE}/img/UserGlass.svg`,
  gesture: `${BASE}/img/gesture.svg`,
  VRLadyMobile: `${BASE}/img/VR-Lady-Mobile.svg`,
  Creme21Logo: `${BASE}/img/Creme21-Logo.svg`,
  AmericanaLogo: `${BASE}/img/Americana-Logo.svg`,
  RaghvaLifeLogo: `${BASE}/img/RaghvaLife-Logo.svg`,
  RaghvaLogo: `${BASE}/img/Raghva-Logo.svg`,
  MedhaLogo: `${BASE}/img/Medha-Logo.svg`,
  KarnatakaTourismLogo: `${BASE}/img/KarnatakaTourism-Logo.svg`,
  RSTLogo: `${BASE}/img/RST-Logo.svg`,
  SpaceLogo: `${BASE}/img/Space-Logo.svg`,
  ImmersiveAnatomyLogo: `${BASE}/img/ImmersiveAnatomy-Logo.svg`,
  NestleLogo: `${BASE}/img/Nestle-Logo.svg`,

  AccessPlatform: `${BASE}/img/AccessPlatform.webp`,
  SpatialgridDashboard: `${BASE}/img/Spatialgrid-Dashboard.webp`,
  ChooseImageTarget: `${BASE}/img/Choose-Image-Target.png`,
  ImageTargetProjectName: `${BASE}/img/Image-Target-Project-Name.png`,
  ChooseSurfaceTarget: `${BASE}/img/Choose-Surface-Target.png`,
  SurfaceTargetProjectName: `${BASE}/img/Surface-Target-Project-Name.png`,
  ChooseWorldTracking: `${BASE}/img/Choose-World-Tracking.png`,
  WorldTrackingProjectName: `${BASE}/img/World-Tracking-Project-Name.png`,
  ChooseVps: `${BASE}/img/Choose-Vps.png`,
  VpsProjectName: `${BASE}/img/Vps-Project-Name.png`,
  AreaTracking: `${BASE}/img/Area-Tracking.png`,
  FaceTracking: `${BASE}/img/Face-Tracking.png`,
  BodyTracking: `${BASE}/img/Body-Tracking.png`,

  ARTecnology: `${BASE}/img/CompressedImage/AR-Tecnology.webp`,
  VRTecnology: `${BASE}/img/CompressedImage/VR-Tecnology.webp`,
  MRTecnology: `${BASE}/img/CompressedImage/MR-Tecnology.webp`,

  SreeNidhiLogo: `${BASE}/img/SreeNidhi-Logo.svg`,
  americana1: `${BASE}/img/americana1.png`,
  americana2: `${BASE}/img/CompressedImage/americana2.webp`,
  BlogPageImage: `${BASE}/img/BlogPageImage.png`,
  Anatomy1: `${BASE}/img/CompressedImage/Anatomy-1.webp`,
  Anatomy2: `${BASE}/img/CompressedImage/Anatomy-2.webp`,
  Raghva1: `${BASE}/img/Raghva-1.png`,
  Raghva2: `${BASE}/img/Raghva-2.png`,
  RST1: `${BASE}/img/RST-1.png`,
  RST2: `${BASE}/img/RST-2.png`,
  Space4D1: `${BASE}/img/Space-4D-1.png`,
  Space4D2: `${BASE}/img/Space-4D-2.png`,
  RaghavaLIfeSciences1: `${BASE}/img/Raghava-life-sciences-1.png`,
  RaghavaLIfeSciences2: `${BASE}/img/Raghava-life-sciences-2.png`,

  ManipalMeetup: `${BASE}/img/ManipalMeetup.jpg`,
  IsroMeetup: `${BASE}/img/IsroMeetup.jpg`,
  BlogArticle1: `${BASE}/img/CompressedImage/BlogArticle-1.webp`,
  BlogArticle2: `${BASE}/img/CompressedImage/BlogArticle-2.webp`,

  InteractionUi: `${BASE}/img/Interaction-Ui.png`,
  LocationBasedAnalysis: `${BASE}/img/Location-Based-Analysis.png`,
  NewReturning: `${BASE}/img/New-Returning.png`,
  SalesDeployment: `${BASE}/img/Sales-Deployment.png`,
  Userbehaviour: `${BASE}/img/Userbehaviour.png`,
  UserSegmentation: `${BASE}/img/UserSegementation.png`,
  Singareni1: `${BASE}/img/Singareni-1.png`,

  Defence1: `${BASE}/img/CompressedImage/Defence-1.webp`,
  Defence2: `${BASE}/img/Defence-2.png`,
  Creme21First: `${BASE}/img/Creme21-1.png`,
  Creme21Second: `${BASE}/img/Creme21-2.png`,
  SpaceDm1: `${BASE}/img/Spacedm-1.png`,
  SpaceDm2: `${BASE}/img/Spacedm-2.png`,

  Singareni2: `${BASE}/img/Singareni-2.png`,
  S26First: `${BASE}/img/S26-1.png`,
  S26Second: `${BASE}/img/S26-2.png`,
  Medha1: `${BASE}/img/Medha-1.png`,
  Medha2: `${BASE}/img/Medha-2.png`,

  DiscoverImmerseMobile: `${BASE}/img/CompressedImage/Discover-Immerse-Mobile.webp`,
  CarMachenic1: `${BASE}/img/CompressedImage/CarMachenic-1.webp`,
  CarMachenic2: `${BASE}/img/CompressedImage/CarMachenic-2.webp`,
  AnalyticsIntroduction: `${BASE}/img/Analytics-Introduction.png`,
  ExperienceTraffic: `${BASE}/img/Experience-Traffic.png`,
  ExperienceOverview: `${BASE}/img/Experience-Overview.png`,
  AnalyticsSummryHeader: `${BASE}/img/Analytics-Summry-Header.png`,
  CountryBasedAnalysis: `${BASE}/img/Country-Based-Analysis.png`,
  HeatmapBehaviour: `${BASE}/img/Heatmap-Behaviour.png`,
  ErrorTracking: `${BASE}/img/Error-Tracking.png`,
  ConversionTracking: `${BASE}/img/Conversion-Tracking.png`,

  retailECommerce: `${BASE}/img/Retail-E-Commerce.webp`,
  experienceProduct: `${BASE}/img/Experience-Product.webp`,
  IndustrialWeb: `${BASE}/img/IndustrialWeb.webp`,
  Manufacturing: `${BASE}/img/Manufacturing.webp`,
  HealthCarePharma: `${BASE}/img/HealthCare-Pharma.webp`,
  SaferTraining: `${BASE}/img/Safer-Training.webp`,
  EducationTraining: `${BASE}/img/Education-Training.webp`,
  EducationSticks: `${BASE}/img/Education-Sticks.webp`,
  AutomotiveTransportation: `${BASE}/img/CompressedImage/Automotive-Transportation.webp`,
  DriveSmarter: `${BASE}/img/Drive-Smarter.webp`,
  RealStateArchitecture: `${BASE}/img/Architecture-RealState.webp`,
  SpaceRealized: `${BASE}/img/Space-Realized.webp`,
  DefenceAerospace: `${BASE}/img/Defence-Aerospace.webp`,
  MissionReady: `${BASE}/img/Mission-Ready.webp`,
  EnergyMIning: `${BASE}/img/Energy-Mining.webp`,
  Operate: `${BASE}/img/Operate.webp`,
  TourismHospitality: `${BASE}/img/Tourism-Hospitality.webp`,
  DiscoverImmerce: `${BASE}/img/Discover-Immerse.webp`,
  KarnatakaTourism: `${BASE}/img/Karnataka-Tourism.webp`,
  Nestle: `${BASE}/img/Nestle.webp`,
  retailEcommerceMobile: `${BASE}/img/retailEcommerceMobile.webp`,
  immersiveAnatomy: `${BASE}/img/Immersive-Anatomy.webp`,
  DriveSmarterMobile: `${BASE}/img/DriveSmarterMobile.webp`,
  mindLabsSection: `${BASE}/img/MindLab-Section.webp`,
  ManufacturingMobile: `${BASE}/img/ManufacturingMobile.webp`,

  KarnatakaTourism1: `${BASE}/img/CompressedImage/Karnataka-Tourism-1.webp`,
  KarnatakaTourism2: `${BASE}/img/CompressedImage/Karnataka-Tourism-2.webp`,
  SpatialGridRenewableEnergy: `${BASE}/img/CompressedImage/SpatialGrid-Renewable-Energy.webp`,
  Flight: `${BASE}/img/Flight.png`,

  //====================== Trending Topics Document Images ====================//
  CreateExperience: `${BASE}/img/trendingtopics/Create-Experience.png`,
  GenerateAssets: `${BASE}/img/trendingtopics/Generate-Assets.png`,
  McpSearch: `${BASE}/img/trendingtopics/Mcp-Search.png`,
  GridProject: `${BASE}/img/trendingtopics/Grid-Project.png`,
  UseAssets: `${BASE}/img/trendingtopics/Use-Assets.png`,
  ThreeDModel: `${BASE}/img/trendingtopics/ThreeDModel.png`,
  RequiredAssets: `${BASE}/img/trendingtopics/Required-Assets.png`,
  Preview: `${BASE}/img/trendingtopics/Preview.png`,
  Share: `${BASE}/img/trendingtopics/Share.png`,
  Share2: `${BASE}/img/trendingtopics/Share2.png`,
  ARPublish: `${BASE}/img/trendingtopics/AR-Publish.png`,
  VRPublish: `${BASE}/img/trendingtopics/VR-Publish.png`,
  ProcessInput: `${BASE}/img/trendingtopics/Process-Input.png`,
  TrainingSection: `${BASE}/img/trendingtopics/Training-Section.png`,
  UploadDocument: `${BASE}/img/trendingtopics/Upload-Document.png`,
  ReviewEdit: `${BASE}/img/trendingtopics/Review-Edit.png`,
  TeamSetup: `${BASE}/img/trendingtopics/Team-Setup.png`,
  SelectAsset: `${BASE}/img/trendingtopics/Select-Asset.png`,
  NewProject: `${BASE}/img/trendingtopics/New-Project.png`,
  PublishTrainingExperience: `${BASE}/img/trendingtopics/Publish-Training-Experience.png`,
  PublishStoryBoard: `${BASE}/img/trendingtopics/Publish-StoryBoard.png`,
  AnalyzedAssets: `${BASE}/img/trendingtopics/Analyzed-Assets.png`,
  CarMechanicLogo: `${BASE}/img/CarMechanic-Logo.svg`,

  //================= New Images ==================//
  VRAssets: `${BASE}/img/trendingtopics/VR-Assets.png`,
  VRARConvert: `${BASE}/img/trendingtopics/VR-AR-Convert.png`,
  VRARSwitch: `${BASE}/img/trendingtopics/VR-AR-Switch.png`,
  VRARWillChange: `${BASE}/img/trendingtopics/VR-AR-Will-Change.png`,
  VRARTrackingMode: `${BASE}/img/trendingtopics/VR-AR-Tracking-Mode.png`,
  VRMRConvert: `${BASE}/img/trendingtopics/VR-MR-Convert.png`,
  VRMRSwitch: `${BASE}/img/trendingtopics/VR-MR-Switch.png`,
  VRMRWillChange: `${BASE}/img/trendingtopics/VR-MR-Will-Change.png`,
  VRMRLoadNotice: `${BASE}/img/trendingtopics/VR-MR-Load-Notice.png`,

  VRXRConvert: `${BASE}/img/trendingtopics/VR-XR-Convert.png`,
  VRXRSwitch: `${BASE}/img/trendingtopics/VR-XR-Switch.png`,
  VRXRWillChange: `${BASE}/img/trendingtopics/VR-XR-Will-Change.png`,
  VRXRLoadNotice: `${BASE}/img/trendingtopics/VR-XR-Load-Notice.png`,
  ARVRConvert: `${BASE}/img/trendingtopics/AR-VR-Convert.png`,
  ARVRSwitch: `${BASE}/img/trendingtopics/AR-VR-Switch.png`,
  ARVRWillChange: `${BASE}/img/trendingtopics/AR-VR-Will-Change.png`,
  ARVRLoadNotice: `${BASE}/img/trendingtopics/AR-VR-Load-Notice.png`,

  ARMRConvert: `${BASE}/img/trendingtopics/AR-MR-Convert.png`,
  ARMRSwitch: `${BASE}/img/trendingtopics/AR-MR-Switch.png`,
  ARMRWillChange: `${BASE}/img/trendingtopics/AR-MR-Will-Change.png`,
  ARMRLoadNotice: `${BASE}/img/trendingtopics/AR-MR-Load-Notice.png`,

  MRVRConvert: `${BASE}/img/trendingtopics/MR-VR-Convert.png`,
  MRVRSwitch: `${BASE}/img/trendingtopics/MR-VR-Switch.png`,
  MRVRWillChange: `${BASE}/img/trendingtopics/VR-MR-Will-Change.png`,
  MRVRLoadNotice: `${BASE}/img/trendingtopics/VR-MR-Load-Notice.png`,

  ISUW26: `${BASE}/img/ISUW26.webp`,
  MCP: `${BASE}/img/MCP.webp`,
};

/* ================= VIDEOS ================= */

export const videoPath = {
  industrial: `${BASE}/video/First-Industrial.mp4`,
  arPhone: `${BASE}/video/First-AR-Phone.mp4`,
  lunar: `${BASE}/video/First-Lunar.mp4`,
  edutech: `${BASE}/video/Edutech.mp4`,
  simulation: `${BASE}/video/Simulation.mp4`,
  prototype: `${BASE}/video/PrototypeDrone.mp4`,
  gamification: `${BASE}/video/gamification.mp4`,
  salesandmarketing: `${BASE}/video/sales-marketing.mp4`,

  MRShoes: `${BASE}/video/MR_Shoes.mp4`,

  cocos: `${process.env.REACT_APP_IMAGE_BASE_URL}uploads/static-images-frontend/cocos.mp4`,
  education: `${process.env.REACT_APP_IMAGE_BASE_URL}uploads/spatialgrid-videos/heart.mp4`,
  drilling: `${process.env.REACT_APP_IMAGE_BASE_URL}uploads/spatialgrid-videos/magnatic_drilling_mechine.mp4`,
  motor: `${process.env.REACT_APP_IMAGE_BASE_URL}uploads/spatialgrid-videos/motor.mp4`,
  chair: `${process.env.REACT_APP_IMAGE_BASE_URL}uploads/spatialgrid-videos/chair_simlation.mp4`,

  ARAnatomy: `${BASE}/video/AR-Anatomy.mp4`,
  VRHeadset: `${BASE}/video/CompressedVideo/VR-Headset.mp4`,
  DigtalTwins: `${BASE}/video/Digital-Twins.mp4`,
  MRGlasses: `${BASE}/video/MR-Glasses.mp4`,

  // ================= Spatial Ai Page Videos ==================//
  AgenticAiRealtime: `${BASE}/video/AgenticAi-Realtime.mp4`,
  AutomatedTraining: `${BASE}/video/Automated-Training.mp4`,
  PromptBasedControl: `${BASE}/video/PromptBased-Control.mp4`,

  // ================= Analytics Page Videos ==================//
  Analytics: `${BASE}/video/Analytics.mp4`,
  BehaviourMapping: `${BASE}/video/Behaviour-Mapping.mp4`,
  PerformenceOutcomeTracking: `${BASE}/video/Performance-Outcome-Tracking.mp4`,

  // ================= Platform Overview Page Videos ==================//
  AccelerateWork: `${BASE}/video/Accelerate-Work.mp4`,
  CollaborativeProject: `${BASE}/video/CompressedVideo/Collabrative-Project-Work.mp4`,
  FromConcept: `${BASE}/video/CompressedVideo/From-Concept.mp4`,

  AmericanaVideo: `${BASE}/video/CompressedVideo/Americana-Video.mp4`,
  Creme21Video: `${BASE}/video/Creme-21-Video.mp4`,
  ImmersiveAnatomyResearch: `${BASE}/video/Immersive-Anotomy-Research.mp4`,
  RaghavaVideo: `${BASE}/video/Raghava-Video.mp4`,
  WebsiteDemo: `${BASE}/video/CompressedVideo/Website-Demo.mp4`,
  DefenceVideo: `${BASE}/video/CompressedVideo/Defence-Video.mp4`,
  SpacedmVideo: `${BASE}/video/CompressedVideo/Spacedm-Video.mp4`,

  RaghavaLifeVideo: `${BASE}/video/RaghavaLife-Video.mp4`,
  RSTVideo: `${BASE}/video/RST-Video.mp4`,
  SingareniVideo: `${BASE}/video/CompressedVideo/Singareni-Video.mp4`,
  S26Video: `${BASE}/video/S26-Video.mp4`,
  Space4D: `${BASE}/video/CompressedVideo/Space-4D.mp4`,
  Medha: `${BASE}/video/CompressedVideo/Medha.mp4`,

  CarMachenicVideo: `${BASE}/video/CarMachenic-Video.mp4`,
  RealTimePosition: `${BASE}/video/CompressedVideo/Real-Time-Position.mp4`,
  PresenceAwarenesAvatars: `${BASE}/video/Presence-Awarenes-Avatars.mp4`,
  InteractionZonesCell: `${BASE}/video/CompressedVideo/Interaction-Zones-Cell.mp4`,
  //================= New Videos ==================//
  KarnatakaTourismVideo: `${BASE}/video/Karnataka-Tourism-Video.mp4`,
  DemoPlay: `${BASE}/video/home/Demo_Play.mp4`,
};

/* ================= ICONS ================= */

export const iconsPath = {
  menuIcon: `${BASE}/icons/Group 11.svg`,
  Vector44Image: `${BASE}/icons/Vector44.svg`,
  Vector45Image: `${BASE}/icons/Vector45.svg`,
  backarrowImage: `${BASE}/icons/BackArrow.svg`,
  group598Image: `${BASE}/icons/Group598.svg`,
  group112Image: `${BASE}/icons/Group112.svg`,
  group750Image: `${BASE}/icons/Group750.svg`,
  logoutIcon: `${BASE}/icons/logout.svg`,

  PlayIcon: `${BASE}/icons/playIcon.svg`,
  QRIcon: `${BASE}/icons/QRIcon.svg`,

  plusIcon: `${BASE}/icons/plusIcon.svg`,
  minusIcon: `${BASE}/icons/minusIcon.svg`,
  rightArrowRed: `${BASE}/icons/RightArrowRed.svg`,
  googleIcon: `${BASE}/icons/GoogleIcon.svg`,
  leftIcon: `${BASE}/icons/LeftIcon.svg`,
  downIcon: `${BASE}/icons/DownIcon.svg`,
  rightIcon: `${BASE}/icons/RightIcon.svg`,
  closeIcon: `${BASE}/icons/closeIcon.svg`,
  folderIcon: `${BASE}/icons/FolderIcon.svg`,
  eyeIcon: `${BASE}/icons/EyeIcon.svg`,

  perspective: `${BASE}/icons/perspective.svg`,
  orthographic: `${BASE}/icons/orthographic.svg`,
  spatialgridLogo: `${BASE}/icons/spatialgrid-logo.png`,

  platformOverview: `${BASE}/icons/platform-overview.svg`,
  multiPlayer: `${BASE}/icons/multiplayer.svg`,
  operatingSystem: `${BASE}/icons/operating-system.svg`,
  realtimeAnalytics: `${BASE}/icons/realtime-analytics.svg`,
  spatialAi: `${BASE}/icons/spatial-ai.svg`,
  documentation: `${BASE}/icons/Documentation.svg`,
  helpCenter: `${BASE}/icons/Help-Center.svg`,
  spatialgridBlog: `${BASE}/icons/Spatialgrid-Blog.svg`,
  spatialgridResearch: `${BASE}/icons/Spatialgrid-Research.svg`,
  universityAlliance: `${BASE}/icons/University-Alliance.svg`,
  transportation: `${BASE}/icons/Transportation.svg`,
  manufacturingIndustrial: `${BASE}/icons/Manufacturing-Industrial.svg`,
  retailEcommerce: `${BASE}/icons/Retail-Ecommerce.svg`,
  realEstate: `${BASE}/icons/Real-Estate.svg`,
  tourismHospitality: `${BASE}/icons/Tourism-Hospitality.svg`,
  healthcare: `${BASE}/icons/HealthCare.svg`,
  defence: `${BASE}/icons/Defence.svg`,
  educationTraining: `${BASE}/icons/Education-Training.svg`,
  oilGas: `${BASE}/icons/Oil-Gas.svg`,
  venture: `${BASE}/icons/Ventures.svg`,
  whoAre: `${BASE}/icons/WhoAre.svg`,
  team: `${BASE}/icons/Team.svg`,
  security: `${BASE}/icons/Security.svg`,
  press: `${BASE}/icons/Press.svg`,
  position: `${BASE}/icons/Positions.svg`,
  contactUs: `${BASE}/icons/ContactUs.svg`,

  SpatialAwearness: `${BASE}/icons/SpatialAwearness.svg`,
  ImmersiveInterface: `${BASE}/icons/ImmersiveInterface.svg`,
  ThreeDSystem: `${BASE}/icons/3DSystem.svg`,
  usingSpatialGrid: `${BASE}/icons/UsingSpatialgrid.svg`,
  Troubleshooting: `${BASE}/icons/TroubleShooting.svg`,
  Partnerships: `${BASE}/icons/Partnerships.svg`,
  Licensing: `${BASE}/icons/Licensing.svg`,
  gettingStarted: `${BASE}/icons/GettingStarted.svg`,
  Alliance: `${BASE}/icons/alliance.svg`,

  uiDesigner: `${BASE}/icons/Ui-Designer.svg`,
  uxDesigner: `${BASE}/icons/Ux-Designer.svg`,
  designHead: `${BASE}/icons/Design-Head.svg`,
  frontendDeveloper: `${BASE}/icons/Frontend-Developer.svg`,
  backendDeveloper: `${BASE}/icons/Backend-Developer.svg`,
  fullstackDeveloper: `${BASE}/icons/Fullstack-Developer.svg`,
  baManager: `${BASE}/icons/Ba-Manager.svg`,
  projectManager: `${BASE}/icons/Project-Manager.svg`,
  hrManager: `${BASE}/icons/Hr-Manager.svg`,
  qaTester: `${BASE}/icons/Qa-Tester.svg`,
  sqlTester: `${BASE}/icons/Sql-Tester.svg`,
  manualTester: `${BASE}/icons/Manual-Tester.svg`,

  clock: `${BASE}/icons/clock.svg`,
  calender: `${BASE}/icons/calendar.svg`,
  duration: `${BASE}/icons/durarion.svg`,
  timer: `${BASE}/icons/timer.svg`,

  learn: `${BASE}/icons/learn.svg`,
  intregrate: `${BASE}/icons/intregate.svg`,
  understand: `${BASE}/icons/understand.svg`,
  experience: `${BASE}/icons/experience.svg`,

  modularBusiness: `${BASE}/icons/modular_business.svg`,
  agenticLoop: `${BASE}/icons/agentic_loop.svg`,
  analytics: `${BASE}/icons/analytics.svg`,
  experienceGeneration: `${BASE}/icons/experience_generation.svg`,

  safety: `${BASE}/icons/safety.svg`,
  retail: `${BASE}/icons/retail.svg`,
  machinery: `${BASE}/icons/machinery.svg`,
  manufacturing: `${BASE}/icons/manufacturing.svg`,
  enterprize: `${BASE}/icons/enterprize.svg`,

  realWorld1: `${BASE}/icons/realWorld1.svg`,
  realWorld2: `${BASE}/icons/realWorld2.svg`,

  HelpCenterSearch: `${BASE}/icons/HelpCenterSearch.svg`,
  LetsTalk: `${BASE}/icons/LetsTalk.svg`,
  MultipleTracking: `${BASE}/icons/Multiple-Tracking.svg`,
  SituationalAwearness: `${BASE}/icons/Situational-Awearness.svg`,
  EthicalExperience: `${BASE}/icons/Ethical-Experience.svg`,
  IntellegenceAcross: `${BASE}/icons/Intellegence-Across.svg`,
  LetsTalkArrow: `${BASE}/icons/LetsTalkArrow.svg`,

  LearnImmersive: `${BASE}/icons/LearnImmersive.svg`,
  ImproveRetention: `${BASE}/icons/ImproveRetention.svg`,
  IncreaseEngagement: `${BASE}/icons/IncreaseEngagement.svg`,
  KnoweledgeClassroom: `${BASE}/icons/KnoweledgeClassroom.svg`,
  TrainingCosts: `${BASE}/icons/TrainingCosts.svg`,
  InteractiveGalleries: `${BASE}/icons/Interactive-Galleries.svg`,
  LocationBasedNavigation: `${BASE}/icons/Location-Based-Navigation.svg`,
  EnhencedHospitality: `${BASE}/icons/Enhenced-Hospitality.svg`,
  ImmersiveVirtualTour: `${BASE}/icons/Immersive-Virtual-Tour.svg`,
  DigitalPreservation: `${BASE}/icons/Digital-Preservation.svg`,

  //================= New Icons ==================//
  GlobalTeam: `${BASE}/icons/GlobalTeam.svg`,
  TrainingEmployee: `${BASE}/icons/TrainingEmployee.svg`,
  AccuratePerformence: `${BASE}/icons/AccuratePerformence.svg`,
  ZeroRisk: `${BASE}/icons/ZeroRisk.svg`,
  ManufacturingSkill: `${BASE}/icons/ManufacturingSkill.svg`,
  LowerTraining: `${BASE}/icons/LowerTraining.svg`,
  ErrorCompliance: `${BASE}/icons/ErrorCompliance.svg`,
  Realasticsimulation: `${BASE}/icons/Realasticsimulation.svg`,
  RetentionMastery: `${BASE}/icons/RetentionMastery.svg`,
  GlobalFacilities: `${BASE}/icons/GlobalFacilities.svg`,
  VisualizeProducts: `${BASE}/icons/VisualizeProducts.svg`,
  ReturnSatisfaction: `${BASE}/icons/ReturnSatisfaction.svg`,
  EngagementConversion: `${BASE}/icons/EngagementConversion.svg`,
  FleetsFacilities: `${BASE}/icons/FleetsFacilities.svg`,
  TrainingPrototype: `${BASE}/icons/TrainingPrototype.svg`,
  InteractiveExperience: `${BASE}/icons/InteractiveExperience.svg`,
  PropertiesEnvironment: `${BASE}/icons/PropertiesEnvironment.svg`,
  CollabrationClients: `${BASE}/icons/CollabrationClients.svg`,
  FeildDecision: `${BASE}/icons/Feild-Decision.svg`,
  MissileSimulation: `${BASE}/icons/MissileSimulation.svg`,
  EngagementAwearness: `${BASE}/icons/EngagementAwearness.svg`,
  CostsAssets: `${BASE}/icons/CostsAssets.svg`,
};

export const gifsPath = {
  Animation: `${BASE}/gifs/Animation.gif`,
  Coding: `${BASE}/gifs/Coding.gif`,
  Controler: `${BASE}/gifs/Controler.gif`,
  DragDrop: `${BASE}/gifs/Drag-Drop.gif`,
  IndustrialTemplate: `${BASE}/gifs/Industrial-Template.gif`,
  Interaction: `${BASE}/gifs/Interaction.gif`,
  Physics: `${BASE}/gifs/Physics.gif`,
  MaterialChange: `${BASE}/gifs/Material-Change.gif`,
};
